/**
 * Sierra Chat Configuration
 * Externalized from theme.liquid for better caching
 * Configuration is populated via data attribute in HTML
 */

(function() {
  'use strict';
  
  // Get config from data attribute
  const configElement = document.getElementById('sierra-config-data');
  const customerUrl = configElement ? configElement.dataset.customerUrl : window.location.href;
  
  // Sierra Configuration
  window.sierraConfig = {
    "initialUserMessage": "",
    "display": "corner",
    "dimensions": {
      "width": "30em",
      "height": "40em"
    },
    "customStyle": {
      "zIndex": "2147483646"
    },
    "colors": {
      "background": "#ffffff",
      "text": "#2b2e2f",
      "border": "#e0e0e0",
      "titleBar": "#f8f4ef",
      "titleBarText": "#2b2e2f",
      "assistantBubble": "#eaeaea",
      "assistantBubbleText": "#2b2e2f",
      "userBubble": "#f8f4ef",
      "userBubbleText": "#2b2e2f"
    },
    "launcher": {
      "backgroundColor": "#2b2e2f",
      "textColor": "#ffffff",
      "text": "",
      "icon": "oval",
      "notificationColor": "#ff0000",
      "customStyle": {
        "zIndex": "100"
      },
      "position": {
        "bottom": "1rem",
        "right": "8px"
      }
    },
    "persistence": "tab",
    "hideOnClose": true,
    onDisabled: function() {
      console.log('Sierra Chat has been disabled.');
      
      const chatLauncher = document.querySelector('button[title="Open Chat"]');
      if (chatLauncher) {
        chatLauncher.style.display = 'none';
      }
      
      const proactiveBannerButton = document.querySelector('button[aria-label="open chat"]');
      if (proactiveBannerButton) {
        proactiveBannerButton.style.display = 'none';
      }
    },
    variables: {
      "customer_initial_url": customerUrl
    }
  };
  
  // Enhanced accessibility configuration
  function observeSierraLauncher() {
    function setupLauncher(launcher) {
      launcher.style.bottom = '1rem';
      launcher.style.right = '8px';
      
      launcher.setAttribute('aria-label', 'Open customer support chat');
      launcher.setAttribute('title', 'Customer Support Chat');
      launcher.setAttribute('tabindex', '0');
      
      if (!document.getElementById('chat-announcements')) {
        const announcements = document.createElement('div');
        announcements.id = 'chat-announcements';
        announcements.setAttribute('aria-live', 'polite');
        announcements.setAttribute('aria-atomic', 'true');
        announcements.style.position = 'absolute';
        announcements.style.left = '-10000px';
        announcements.style.width = '1px';
        announcements.style.height = '1px';
        announcements.style.overflow = 'hidden';
        document.body.appendChild(announcements);
      }
      
      launcher.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          launcher.click();
          document.getElementById('chat-announcements').textContent = 'Opening customer support chat';
        }
      }, { once: true });
    }
    
    const host = document.querySelector('[data-sierra-chat-launcher]');
    if (host?.shadowRoot) {
      const launcher = host.shadowRoot.querySelector('button');
      if (launcher) {
        setupLauncher(launcher);
        return;
      }
    }
    
    const observer = new MutationObserver(function() {
      const host = document.querySelector('[data-sierra-chat-launcher]');
      const launcher = host?.shadowRoot?.querySelector('button');
      if (launcher) {
        setupLauncher(launcher);
        observer.disconnect();
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    setTimeout(function() { observer.disconnect(); }, 10000);
  }
  
  // AccessiBe compatibility
  function ensureAccessiBeCompatibility() {
    const accessiBeActive = document.querySelector('[data-accessibe-overlay]') ||
                           document.querySelector('.accessibe-overlay') ||
                           window.accessiBe;
    
    if (!accessiBeActive) return;
    
    const metaTag = document.createElement('meta');
    metaTag.name = 'accessibility-statement';
    metaTag.content = 'This site has native accessibility features. Screen reader users may disable overlay for optimal experience.';
    document.head.appendChild(metaTag);
    
    const skipAccessiBe = document.createElement('button');
    skipAccessiBe.className = 'skip-to-content sr-only';
    skipAccessiBe.textContent = 'Skip accessibility overlay (for screen reader users)';
    skipAccessiBe.style.position = 'fixed';
    skipAccessiBe.style.top = '0';
    skipAccessiBe.style.left = '0';
    skipAccessiBe.style.zIndex = '999999';
    skipAccessiBe.onclick = function() {
      if (window.accessiBe && window.accessiBe.close) {
        window.accessiBe.close();
      } else if (window.acsb && window.acsb.close) {
        window.acsb.close();
      }
      const overlay = document.querySelector('[data-accessibe-overlay]') ||
                     document.querySelector('.accessibe-overlay');
      if (overlay) {
        overlay.style.display = 'none';
      }
      const announcement = document.getElementById('chat-announcements') ||
                         document.createElement('div');
      announcement.textContent = 'Accessibility overlay disabled. Native site accessibility is now active.';
    };
    
    const firstSkipLink = document.querySelector('.skip-to-content');
    if (firstSkipLink) {
      firstSkipLink.parentNode.insertBefore(skipAccessiBe, firstSkipLink.nextSibling);
    }
  }
  
  // Z-index fixer for third-party widgets
  (function() {
    const SAFE_Z_INDEX = '99';
    var observer = null;
    const fixedWidgets = new Set();
    
    function fixAccessiBe() {
      const widget = document.querySelector('access-widget-ui');
      if (widget && !fixedWidgets.has('accessiBe')) {
        widget.style.setProperty('z-index', SAFE_Z_INDEX, 'important');
        
        if (widget.shadowRoot && !widget.shadowRoot.querySelector('#acsb-z-fix')) {
          const style = document.createElement('style');
          style.id = 'acsb-z-fix';
          style.textContent = ':host, .trigger-button, button[part="acsb-trigger"] { z-index: ' + SAFE_Z_INDEX + ' !important; }';
          widget.shadowRoot.appendChild(style);
        }
        
        fixedWidgets.add('accessiBe');
        console.log('✓ accessiBe z-index fixed');
        return true;
      }
      return false;
    }
    
    function fixAttentive() {
      const overlay = document.getElementById('attentive_overlay');
      const creative = document.getElementById('attentive_creative');
      
      if ((overlay || creative) && !fixedWidgets.has('attentive')) {
        if (overlay) overlay.style.setProperty('z-index', SAFE_Z_INDEX, 'important');
        if (creative) creative.style.setProperty('z-index', SAFE_Z_INDEX, 'important');
        fixedWidgets.add('attentive');
        console.log('✓ Attentive z-index fixed');
        return true;
      }
      return false;
    }
    
    function attemptFixes() {
      const accessiBeFixed = fixAccessiBe();
      const attentiveFixed = fixAttentive();
      
      if (fixedWidgets.size >= 2 && observer) {
        observer.disconnect();
        observer = null;
      }
      
      return accessiBeFixed || attentiveFixed;
    }
    
    function startObserver() {
      if (observer || fixedWidgets.size >= 2) return;
      
      observer = new MutationObserver(function() { attemptFixes(); });
      observer.observe(document.body, { childList: true, subtree: true });
      
      setTimeout(function() {
        if (observer) {
          observer.disconnect();
          observer = null;
        }
      }, 15000);
    }
    
    const runFixes = function() {
      if (!attemptFixes()) startObserver();
    };
    
    document.addEventListener('DOMContentLoaded', runFixes);
    setTimeout(runFixes, 1000);
    setTimeout(runFixes, 3000);
    setTimeout(runFixes, 5000);
  })();
  
  // Initialize
  observeSierraLauncher();
  document.addEventListener('DOMContentLoaded', ensureAccessiBeCompatibility);
  setTimeout(ensureAccessiBeCompatibility, 2000);
  setTimeout(ensureAccessiBeCompatibility, 5000);
})();
